import React, { useEffect, useMemo, useState } from "react"
import { IMG } from "../../CONST"
import { HeaderProfileList } from "../HeaderProfileList"
import { ProfileEdit } from "../../element/ProfileEdit"
import { PasswordEdit } from "../../element/PasswordEdit"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { useCurrencyStore } from "@/stores/currencyStore"
import HoverMenu, { HoverMenuOption } from "@/ui/components/HoverMenu"

import style from "./style.module.scss"
import { Link } from "react-router-dom"
import { DASHBOARD_ROUTE } from "@/routes"
import clsx from "clsx"
import { BurgerMenu } from "./BurgerMenu"

export const Header: React.FC<{ clazzName?: string }> = ({ clazzName }) => {
  const currencyDate = useCurrencyStore(state => state.date)
  const setCurrencyDate = useCurrencyStore(state => state.setDate)
  const currencies = useCurrencyStore(state => state.currencies)
  const setCurrencies = useCurrencyStore(state => state.setCurrencies)
  const setBcaCurrencies = useCurrencyStore(state => state.setBcaCurrencies)
  const selectedCurrency = useCurrencyStore(state => state.selectedCurrency)
  const setSelectedCurrency = useCurrencyStore(state => state.setSelectedCurrency)
  const setIsCurrencyLoading = useCurrencyStore(state => state.setIsLoading)

  const [showProfileList, setShowProfileList] = useState(false)
  const [showProfileEdit, setShowProfileEdit] = useState(false)
  const [showPasswordEdit, setShowPasswordEdit] = useState(false)
  const [hoverMenuItems, setHoverMenuItems] = useState<Array<HoverMenuOption>>([])
  const [isBurgerMenuOpen, setBurgerMenuOpen] = useState(false)

  const toggleBurgerMenu = () => {
    setBurgerMenuOpen(!isBurgerMenuOpen)
  }

  const selected: HoverMenuOption | null = useMemo(() => {
    if (!currencies) {
      return null
    }

    return {
      value: selectedCurrency,
      label: `${selectedCurrency.toUpperCase()} ${Number(currencies[selectedCurrency]).toFixed(4)}`
    }
  }, [selectedCurrency, currencies])

  const handleSelectCurrency = (option: HoverMenuOption) => {
    setSelectedCurrency(option.value)
  }

  useEffect(() => {
    if (!currencies) {
      return
    }

    const menuItems = ["USD", "EUR", "CNY", "USD/EUR", "USD/CNY"]

    const newMenuItems: Array<HoverMenuOption> = menuItems.map(value => {
      return {
        value,
        label: (
          <p>
            {value?.toUpperCase()} <span>{currencies[value] ? currencies[value]?.toFixed(4) : ""}</span>
          </p>
        )
      }
    })

    setHoverMenuItems(newMenuItems)
  }, [currencies])

  useEffect(() => {
    TrinityAPI.getCurrencyCbr(
      response => {
        if (response.status === 200) {
          const { data } = response

          if (!selectedCurrency) {
            setSelectedCurrency("USD")
          }

          if (data?.currencies?.USD) {
            setCurrencies({
              ...data?.currencies,
              ...data?.xRates
            })
          }

          setCurrencyDate(data.lastUpdate || "")
        }
      },
      () => setIsCurrencyLoading(false)
    )

    TrinityAPI.getCurrencyBca(response => {
      if (response.status === 200) {
        const { data } = response

        if (data?.buy?.USD) {
          setBcaCurrencies({
            sell: {
              ...data.sell
            },
            buy: {
              ...data.buy
            },
            xRates: {
              ...data.xRates
            }
          })
        }
      }
    })
  }, [])

  useEffect(() => {
    if (isBurgerMenuOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }, [isBurgerMenuOpen])

  return (
    <>
      <div className={clsx(clazzName ? clazzName : "header-main", style.headerMain)}>
        <nav className={style.header}>
          <div className={style.headerLogoWrapper}>
            <Link to={DASHBOARD_ROUTE} className={style.logo}>
              <img src={IMG.sign} alt="" className={style.logoImg} />
              <span>trinity</span>
            </Link>

            {currencies && (
              <div className={clsx("flex-row-10 header-main-currencies", style.currencies)}>
                <li className="main-header-item main-header-item--currency">
                  <p className="main-header-item-text">{new Date(currencyDate).toLocaleDateString("ru")}:</p>
                </li>
                <HoverMenu selected={selected} onSelect={handleSelectCurrency} items={hoverMenuItems} />
              </div>
            )}
          </div>

          <div className={style.burgerWrapper}>
            <ul className={clsx("main-header-list", style.mainHeaderList)}>
              <li className="main-header-item" onMouseEnter={() => setShowProfileList(true)}>
                <img src={IMG.profile} alt="" className="main-header-nav-img" />
                <p className="main-header-item-text">Профиль</p>
              </li>
            </ul>

            <div className={clsx(style.burgerIcon, { [style.open]: isBurgerMenuOpen })} onClick={toggleBurgerMenu}>
              <div className={style.bar1}></div>
              <div className={style.bar2}></div>
              <div className={style.bar3}></div>
            </div>
          </div>
        </nav>
      </div>

      <HeaderProfileList
        visible={showProfileList}
        setVisible={setShowProfileList}
        showProfile={() => setShowProfileEdit(true)}
        showPassword={() => setShowPasswordEdit(true)}
      />
      <ProfileEdit visible={showProfileEdit} setVisible={setShowProfileEdit} />
      <PasswordEdit visible={showPasswordEdit} setVisible={setShowPasswordEdit} />

      <BurgerMenu
        isOpen={isBurgerMenuOpen}
        setOpen={setBurgerMenuOpen}
        showPassword={() => setShowPasswordEdit(true)}
      />
    </>
  )
}
